import { Schema, valuesOf } from 'normalizr'

export const broker = new Schema('broker')
export const myBrokers = valuesOf(broker)
